export default __webpack_public_path__ + "static/media/wings-w:-chives.c289dfd2.jpg";